import { ref as L, defineComponent as C, provide as j, onMounted as D, watch as v, computed as S, openBlock as c, createElementBlock as h, normalizeStyle as F, Fragment as O, renderList as I, createBlock as w, unref as f, createCommentVNode as b, renderSlot as _, toRaw as E, inject as P, onBeforeUnmount as $, withCtx as Z } from "vue";
const m = L(!1), Q = (p, M) => {
  const i = document.createElement("script"), e = M != null && M.length > 0 ? `&libraries=${M.join(",")}` : "";
  i.id = "kakao-map-api-script", i.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${p}&autoload=false${e}`, document.body.appendChild(i), i.onload = () => {
    kakao.maps.load(() => {
      m.value = !0;
    });
  };
}, T = /* @__PURE__ */ C({
  __name: "KakaoMap",
  props: {
    width: { default: "40rem" },
    height: { default: "30rem" },
    markerList: {},
    infoWindowList: {},
    markerCluster: {},
    lat: {},
    lng: {},
    level: { default: 3 },
    mapTypeId: {},
    draggable: { type: Boolean, default: !0 },
    scrollwheel: { type: Boolean, default: !0 },
    disableDoubleClick: { type: Boolean, default: !1 },
    disableDoubleClickZoom: { type: Boolean, default: !1 },
    projectionId: { default: "kakao.maps.ProjectionId.WCONG" },
    tileAnimation: { type: Boolean, default: !0 },
    keyboardShortcuts: { type: [Boolean, Object] }
  },
  emits: ["onLoadKakaoMap", "onLoadKakaoMapMarkerCluster"],
  setup(p, { emit: M }) {
    const i = p, e = M, a = L(null), u = L();
    j("mapRef", u);
    const d = () => {
      const n = {
        center: new kakao.maps.LatLng(i.lat, i.lng),
        ...i
      };
      a.value !== null && (u.value = new window.kakao.maps.Map(a.value, n), e("onLoadKakaoMap", u.value));
    }, y = L(), t = (n) => {
      var k, l;
      if (n.markers === void 0 && n.customOverlayProps === void 0)
        throw new Error("클러스터 할 입력값이 없습니다.");
      if (u.value !== null) {
        if (n.markers !== void 0) {
          const o = L([]);
          (k = n.markers) == null || k.forEach((s) => {
            var K;
            const g = new kakao.maps.Marker({
              position: new kakao.maps.LatLng(s.lat, s.lng),
              image: s.image ?? void 0,
              title: s.title ?? void 0,
              draggable: typeof s.draggable == "boolean" ? s.draggable : !1,
              clickable: typeof s.clickable == "boolean" ? s.clickable : !1,
              zIndex: typeof s.zIndex == "number" ? s.zIndex : 0,
              opacity: s.opacity ?? 1,
              altitude: s.altitude ?? 0,
              range: s.range ?? void 0
            });
            (K = o.value) == null || K.push(g);
          }), y.value = new kakao.maps.MarkerClusterer({
            map: E(u.value),
            ...n,
            markers: o.value
          });
        }
        if (n.customOverlayProps !== void 0) {
          const o = L([]);
          (l = n.customOverlayProps) == null || l.forEach((s) => {
            var K;
            const g = new kakao.maps.CustomOverlay({
              position: new kakao.maps.LatLng(s.lat, s.lng),
              content: s.content,
              xAnchor: s.xAnchor,
              yAnchor: s.yAnchor,
              zIndex: s.zIndex,
              clickable: s.clickable
            });
            (K = o.value) == null || K.push(g);
          }), y.value = new kakao.maps.MarkerClusterer({
            map: E(u.value),
            ...n,
            markers: o.value
          });
        }
        e("onLoadKakaoMapMarkerCluster", y.value);
      }
    };
    D(() => {
      m.value && (d(), i.markerCluster !== void 0 && t(i.markerCluster));
    }), v(
      () => m.value,
      (n) => {
        n && (d(), i.markerCluster !== void 0 && t(i.markerCluster));
      }
    );
    const r = S(() => ({
      width: isFinite(+i.width) ? i.width + "px" : i.width,
      height: isFinite(+i.height) ? i.height + "px" : i.height
    }));
    return v([() => i.lat, () => i.lng], ([n, k]) => {
      var l;
      (l = u.value) == null || l.panTo(new kakao.maps.LatLng(n, k));
    }), v(
      () => i.draggable,
      (n) => {
        var k, l;
        n === void 0 || n ? (k = u.value) == null || k.setDraggable(!0) : (l = u.value) == null || l.setDraggable(!1);
      }
    ), v(
      () => i.level,
      (n) => {
        var k, l;
        n === void 0 ? (k = u.value) == null || k.setLevel(3) : (l = u.value) == null || l.setLevel(n);
      }
    ), v(
      () => i.mapTypeId,
      (n) => {
        var k, l;
        n === void 0 ? (k = u.value) == null || k.setMapTypeId(3) : (l = u.value) == null || l.setMapTypeId(n);
      }
    ), v(
      () => i.scrollwheel,
      (n) => {
        var k, l;
        n === void 0 ? (k = u.value) == null || k.setZoomable(!0) : (l = u.value) == null || l.setZoomable(n);
      }
    ), v(
      () => i.projectionId,
      (n) => {
        var k, l;
        n === void 0 ? (k = u.value) == null || k.setProjectionId(kakao.maps.ProjectionId.WCONG) : (l = u.value) == null || l.setProjectionId(n);
      }
    ), v(
      () => i.keyboardShortcuts,
      (n) => {
        var k, l;
        n === void 0 ? (k = u.value) == null || k.setKeyboardShortcuts(!1) : typeof n == "boolean" && ((l = u.value) == null || l.setKeyboardShortcuts(n));
      }
    ), (n, k) => (c(), h("div", {
      ref_key: "kakaoMapRef",
      ref: a,
      style: F(r.value)
    }, [
      i.markerList && i.markerCluster === void 0 ? (c(!0), h(O, { key: 0 }, I(i.markerList, (l, o) => (c(), w(f(B), {
        key: l.key === void 0 ? o : l.key,
        lat: l.lat,
        lng: l.lng,
        "info-window": l == null ? void 0 : l.infoWindow,
        draggable: l.draggable,
        image: l.image,
        order: l.order,
        "order-bottom-margin": l.orderBottomMargin
      }, null, 8, ["lat", "lng", "info-window", "draggable", "image", "order", "order-bottom-margin"]))), 128)) : b("", !0),
      i.infoWindowList && i.markerCluster === void 0 ? (c(!0), h(O, { key: 1 }, I(i.infoWindowList, (l, o) => (c(), w(f(x), {
        key: l.key === void 0 ? o : l.key,
        lat: l.lat,
        lng: l.lng,
        content: l.content,
        visible: l.visible
      }, null, 8, ["lat", "lng", "content", "visible"]))), 128)) : b("", !0),
      _(n.$slots, "default")
    ], 4));
  }
}), N = {
  imageSrc: "https://t1.daumcdn.net/mapjsapi/images/2x/marker.png",
  imageWidth: 29,
  imageHeight: 42,
  imageOption: {}
}, B = /* @__PURE__ */ C({
  __name: "KakaoMapMarker",
  props: {
    lat: {},
    lng: {},
    infoWindow: {},
    visible: { type: Boolean },
    image: {},
    title: {},
    draggable: { type: Boolean },
    clickable: { type: Boolean },
    zIndex: {},
    opacity: {},
    altitude: {},
    range: {},
    order: {},
    orderBottomMargin: {}
  },
  emits: [
    "onLoadKakaoMapMarker",
    "onClickKakaoMapMarker",
    "dragEndKakaoMapMarker",
    "mouseOverKakaoMapMarker",
    "mouseOutKakaoMapMarker",
    "deleteKakaoMapMarker"
  ],
  setup(p, { emit: M }) {
    const i = M, e = p, a = L(), u = P("mapRef"), d = (o) => {
      if (o != null) {
        if (o.imageSrc === void 0)
          throw new Error("이미지 경로가 존재하지 않습니다.");
      } else
        o = N;
      const s = new Image();
      s.src = o.imageSrc;
      const g = new kakao.maps.MarkerImage(
        o.imageSrc,
        new kakao.maps.Size(o.imageWidth ?? s.width, o.imageHeight ?? s.height),
        o.imageOption
      );
      a.value !== void 0 && a.value.setImage(g);
    }, y = (o) => {
      if (e.lat === void 0 || e.lng === void 0)
        throw new Error("marker의 위치가 없습니다.");
      const s = new kakao.maps.LatLng(e.lat, e.lng);
      a.value = new kakao.maps.Marker({
        position: s,
        title: e.title,
        draggable: e.draggable,
        clickable: e.clickable,
        zIndex: e.zIndex,
        opacity: e.opacity,
        altitude: e.altitude,
        range: e.range
      }), d(e.image), i("onLoadKakaoMapMarker", a.value), a.value.setMap(o), t(a.value), n(a.value), k(a.value), r(o, a.value);
    }, t = (o) => {
      kakao.maps.event.addListener(o, "click", () => {
        i("onClickKakaoMapMarker");
      });
    }, r = (o, s) => {
      kakao.maps.event.addListener(s, "dragend", function(g) {
        i("dragEndKakaoMapMarker", s);
      });
    }, n = (o) => {
      kakao.maps.event.addListener(o, "mouseover", () => {
        i("mouseOverKakaoMapMarker");
      });
    }, k = (o) => {
      kakao.maps.event.addListener(o, "mouseout", () => {
        i("mouseOutKakaoMapMarker");
      });
    }, l = (o) => `<div style="position:relative; bottom:${e.orderBottomMargin}">
        ${o}
      </div>`;
    return $(() => {
      var o;
      i("deleteKakaoMapMarker", a), (o = a.value) == null || o.setMap(null);
    }), v(
      [() => m.value, () => u, () => u == null ? void 0 : u.value],
      ([o, s, g]) => {
        o && s !== void 0 && g !== void 0 && y(g);
      },
      { immediate: !0 }
    ), v([() => e.lat, () => e.lng], ([o, s]) => {
      var g;
      m.value && ((g = a.value) == null || g.setPosition(new kakao.maps.LatLng(o, s)));
    }), v([() => e.image], () => {
      d(e.image);
    }), v(
      () => e.title,
      (o) => {
        var s;
        o !== void 0 && ((s = a.value) == null || s.setTitle(o));
      }
    ), v(
      () => e.draggable,
      (o) => {
        var s;
        (s = a.value) == null || s.setDraggable(o !== void 0 && o);
      }
    ), v(
      () => e.clickable,
      (o) => {
        var s;
        (s = a.value) == null || s.setDraggable(o !== void 0 && o);
      }
    ), v(
      () => e.zIndex,
      (o) => {
        var s;
        o !== void 0 && isFinite(o) && ((s = a.value) == null || s.setZIndex(Number(o)));
      }
    ), v(
      () => e.opacity,
      (o) => {
        var s, g;
        o !== void 0 && isFinite(o) ? (s = a.value) == null || s.setOpacity(Number(o)) : (g = a.value) == null || g.setOpacity(1);
      }
    ), (o, s) => {
      var g, K, A;
      return c(), h("div", null, [
        o.$slots.infoWindow ? (c(), w(f(x), {
          key: 0,
          marker: a.value,
          lat: e.lat,
          lng: e.lng,
          visible: (g = e == null ? void 0 : e.infoWindow) == null ? void 0 : g.visible
        }, {
          default: Z(() => [
            _(o.$slots, "infoWindow")
          ]),
          _: 3
        }, 8, ["marker", "lat", "lng", "visible"])) : e.infoWindow ? (c(), w(f(x), {
          key: 1,
          marker: a.value,
          lat: e.lat,
          lng: e.lng,
          content: (K = e == null ? void 0 : e.infoWindow) == null ? void 0 : K.content,
          visible: (A = e == null ? void 0 : e.infoWindow) == null ? void 0 : A.visible
        }, null, 8, ["marker", "lat", "lng", "content", "visible"])) : b("", !0),
        e.order ? (c(), w(f(z), {
          key: 2,
          lat: e.lat,
          lng: e.lng,
          "y-anchor": 0,
          content: l(e.order)
        }, null, 8, ["lat", "lng", "content"])) : b("", !0)
      ]);
    };
  }
}), G = { key: 0 }, x = /* @__PURE__ */ C({
  __name: "KakaoMapInfoWindow",
  props: {
    lat: {},
    lng: {},
    marker: {},
    content: {},
    disableAutoPan: { type: Boolean },
    removable: { type: Boolean, default: !1 },
    zIndex: {},
    altitude: {},
    range: { default: 500 },
    visible: { type: Boolean, default: !0 }
  },
  emits: ["onLoadKakaoMapInfoWindow"],
  setup(p, { emit: M }) {
    const i = M, e = p, a = L(), u = L(), d = P("mapRef"), y = (t) => {
      var n, k;
      if (e.lat === void 0 || e.lng === void 0)
        throw new Error("infoWindow의 위치가 없습니다.");
      const r = new kakao.maps.LatLng(e.lat, e.lng);
      a.value = new kakao.maps.InfoWindow({
        position: r,
        content: u.value ?? e.content ?? "",
        removable: e.removable,
        disableAutoPan: e.disableAutoPan,
        zIndex: e.zIndex,
        altitude: e.altitude,
        range: e.range
      }), e.visible && (i("onLoadKakaoMapInfoWindow", a.value), e.marker !== void 0 ? (n = a == null ? void 0 : a.value) == null || n.open(t, e.marker) : (k = a == null ? void 0 : a.value) == null || k.open(t));
    };
    return $(() => {
      (a == null ? void 0 : a.value) !== null && a.value !== void 0 && a.value.close();
    }), v(
      [() => m.value, () => d == null ? void 0 : d.value, () => m, () => d],
      ([t, r]) => {
        e.visible && t && r !== void 0 && r !== null && y(r);
      },
      { immediate: !0 }
    ), v(
      () => e.marker,
      (t) => {
        var r, n, k;
        !e.visible || (d == null ? void 0 : d.value) === void 0 || (a.value != null && ((r = a.value) == null || r.close()), t !== void 0 ? (n = a == null ? void 0 : a.value) == null || n.open(d == null ? void 0 : d.value, t) : (k = a == null ? void 0 : a.value) == null || k.open(d == null ? void 0 : d.value));
      },
      {
        immediate: !0
      }
    ), v(
      [() => u == null ? void 0 : u.value, () => u],
      ([t]) => {
        var r;
        t !== void 0 && a.value !== void 0 && a.value !== null && ((r = a.value) == null || r.setContent(t));
      },
      { deep: !0 }
    ), v([() => e.lat, () => e.lng], ([t, r]) => {
      var n;
      (n = a.value) == null || n.setPosition(new kakao.maps.LatLng(t, r));
    }), v(
      () => e.content,
      (t) => {
        var r;
        (r = a.value) == null || r.setContent(t ?? "");
      }
    ), v(
      () => e.zIndex,
      (t) => {
        var r;
        (r = a.value) == null || r.setZIndex(t ?? 0);
      }
    ), v(
      () => e.altitude,
      (t) => {
        var r;
        (r = a.value) == null || r.setAltitude(t ?? 0);
      }
    ), v(
      () => e.range,
      (t) => {
        var r;
        (r = a.value) == null || r.setRange(t ?? 500);
      }
    ), v(
      () => e.visible,
      (t) => {
        t ? m != null && m.value && (d == null ? void 0 : d.value) !== void 0 && (d == null ? void 0 : d.value) !== null && y(d.value) : (a == null ? void 0 : a.value) !== null && a.value !== void 0 && a.value.close();
      }
    ), (t, r) => e.content && e.content.length > 0 || t.$slots.default ? (c(), h("div", G, [
      t.$slots.default ? (c(), h("div", {
        key: 0,
        ref_key: "contentSlot",
        ref: u
      }, [
        _(t.$slots, "default")
      ], 512)) : b("", !0)
    ])) : b("", !0);
  }
}), H = { key: 0 }, z = /* @__PURE__ */ C({
  __name: "KakaoMapCustomOverlay",
  props: {
    lat: {},
    lng: {},
    content: {},
    xAnchor: { default: 0.5 },
    yAnchor: { default: 0.5 },
    zIndex: {},
    clickable: { type: Boolean, default: !1 },
    visible: { type: Boolean, default: !0 }
  },
  emits: ["onLoadKakaoMapCustomOverlay"],
  setup(p, { emit: M }) {
    const i = M, e = p, a = L(), u = L(), d = P("mapRef"), y = (t) => {
      if (e.lat === void 0 || e.lng === void 0)
        throw new Error("KakaoMapCustomOverlay의 위치가 없습니다.");
      const r = new kakao.maps.LatLng(e.lat, e.lng);
      a.value = new kakao.maps.CustomOverlay({
        position: r,
        content: u.value ?? e.content ?? "",
        xAnchor: e.xAnchor,
        yAnchor: e.yAnchor,
        zIndex: e.zIndex,
        clickable: e.clickable
      }), e.visible && (a.value.setMap(t), i("onLoadKakaoMapCustomOverlay", a.value));
    };
    return $(() => {
      var t;
      a.value !== null && ((t = a.value) == null || t.setMap(null));
    }), v(
      [() => m.value, () => d == null ? void 0 : d.value, () => m, () => d],
      ([t, r]) => {
        e.visible && t && r !== void 0 && r !== null && y(r);
      },
      { immediate: !0 }
    ), v(
      [() => u == null ? void 0 : u.value, () => u],
      ([t]) => {
        var r;
        t !== void 0 && a.value !== void 0 && a.value !== null && ((r = a.value) == null || r.setContent(t));
      },
      { deep: !0 }
    ), v([() => e.lat, () => e.lng], ([t, r]) => {
      var n;
      (n = a.value) == null || n.setPosition(new kakao.maps.LatLng(t, r));
    }), v(
      () => e.content,
      (t) => {
        var r;
        (r = a.value) == null || r.setContent(t ?? "");
      }
    ), v(
      () => e.zIndex,
      (t) => {
        var r;
        (r = a.value) == null || r.setZIndex(t ?? 0);
      }
    ), v(
      () => e.visible,
      (t) => {
        var r;
        t ? m != null && m.value && (d == null ? void 0 : d.value) !== void 0 && (d == null ? void 0 : d.value) !== null && y(d.value) : (a == null ? void 0 : a.value) !== null && a.value !== void 0 && ((r = a.value) == null || r.setMap(null));
      }
    ), (t, r) => e.content && e.content.length > 0 || t.$slots.default ? (c(), h("div", H, [
      t.$slots.default ? (c(), h("div", {
        key: 0,
        ref_key: "contentSlot",
        ref: u
      }, [
        _(t.$slots, "default")
      ], 512)) : b("", !0)
    ])) : b("", !0);
  }
}), W = /* @__PURE__ */ C({
  __name: "KakaoMapPolyline",
  props: {
    latLngList: {},
    endArrow: { type: Boolean },
    strokeWeight: { default: 3 },
    strokeColor: { default: "#F10000" },
    strokeOpacity: { default: 0.6 },
    strokeStyle: { default: "solid" },
    zIndex: {}
  },
  emits: ["onLoadKakaoMapPolyline"],
  setup(p, { emit: M }) {
    const i = M, e = p, a = P("mapRef"), u = L(), d = S(() => e.latLngList.map((t) => new kakao.maps.LatLng(t.lat, t.lng))), y = (t) => {
      u.value = new kakao.maps.Polyline({
        path: d.value,
        endArrow: e.endArrow,
        strokeWeight: e.strokeWeight,
        strokeColor: e.strokeColor,
        strokeOpacity: e.strokeOpacity,
        strokeStyle: e.strokeStyle,
        zIndex: e.zIndex
      }), u.value.setMap(t), i("onLoadKakaoMapPolyline", u.value);
    };
    return v(
      [() => m.value, () => a == null ? void 0 : a.value, () => m, () => a],
      ([t, r]) => {
        t && r !== void 0 && r !== null && y(r);
      },
      { immediate: !0 }
    ), v(
      () => e.latLngList,
      () => {
        var t;
        (t = u.value) == null || t.setPath(d.value);
      },
      { deep: !0 }
    ), v(
      () => e.endArrow,
      () => {
        var t;
        (t = u.value) == null || t.setMap(null), a !== void 0 && y(a.value);
      }
    ), v(
      [() => e.strokeWeight, () => e.strokeColor, () => e.strokeOpacity, () => e.strokeStyle],
      ([t, r, n, k]) => {
        var l;
        (l = u.value) == null || l.setOptions({
          strokeWeight: t,
          strokeColor: r,
          strokeOpacity: n,
          strokeStyle: k
        });
      }
    ), v(
      () => e.zIndex,
      (t) => {
        var r;
        t !== void 0 && ((r = u.value) == null || r.setZIndex(t));
      }
    ), $(() => {
      var t;
      (t = u.value) == null || t.setMap(null);
    }), (t, r) => (c(), h("div", null, [
      _(t.$slots, "default")
    ]));
  }
}), U = { key: 0 }, V = { key: 1 }, q = /* @__PURE__ */ C({
  __name: "KakaoMapMarkerPolyline",
  props: {
    markerList: {},
    endArrow: { type: Boolean },
    strokeWeight: {},
    strokeColor: {},
    strokeOpacity: {},
    strokeStyle: {},
    zIndex: {},
    showMarkerOrder: { type: Boolean }
  },
  emits: [
    // Marker event
    "onLoadKakaoMapMarker",
    "onClickKakaoMapMarker",
    "dragEndKakaoMapMarker",
    "mouseOverKakaoMapMarker",
    "mouseOutKakaoMapMarker",
    "deleteKakaoMapMarker"
  ],
  setup(p, { emit: M }) {
    const i = M, e = p, a = P("mapRef"), u = L([]), d = (n) => {
      u.value.push(n), i("onLoadKakaoMapMarker", n);
    }, y = (n) => {
      const k = u.value.indexOf(n);
      u.value.splice(k, 1), i("deleteKakaoMapMarker", n);
    }, t = (n) => {
      const k = e.markerList, l = u.value.indexOf(n);
      k[l].lat = n.getPosition().getLat(), k[l].lng = n.getPosition().getLng(), i("dragEndKakaoMapMarker", n);
    }, r = (n, k) => `<div style="position:relative; bottom:${k}">
        ${n}
      </div>`;
    return (n, k) => (c(), h(O, null, [
      e.markerList && f(a) !== null ? (c(), h("div", U, [
        (c(!0), h(O, null, I(e.markerList, (l, o) => (c(), w(f(B), {
          id: o,
          key: l.key === void 0 ? o : l.key,
          map: f(a),
          lat: l.lat,
          lng: l.lng,
          draggable: l.draggable,
          clickable: l.clickable,
          image: l.image,
          onOnLoadKakaoMapMarker: d,
          onDragEndKakaoMapMarker: t,
          onDeleteKakaoMapMarker: y,
          onOnClickKakaoMapMarker: (s) => i("onClickKakaoMapMarker", l),
          onMouseOverKakaoMapMarker: (s) => i("mouseOverKakaoMapMarker", l),
          onMouseOutKakaoMapMarker: (s) => i("mouseOutKakaoMapMarker", l)
        }, null, 8, ["id", "map", "lat", "lng", "draggable", "clickable", "image", "onOnClickKakaoMapMarker", "onMouseOverKakaoMapMarker", "onMouseOutKakaoMapMarker"]))), 128)),
        (c(!0), h(O, null, I(e.markerList, (l, o) => (c(), h("div", { key: o }, [
          o !== e.markerList.length - 1 ? (c(), w(f(W), {
            key: 0,
            latLngList: [
              { lat: e.markerList[o].lat, lng: e.markerList[o].lng },
              { lat: e.markerList[o + 1].lat, lng: e.markerList[o + 1].lng }
            ],
            endArrow: e.endArrow,
            strokeWeight: e.strokeWeight,
            strokeColor: e.strokeColor,
            strokeOpacity: e.strokeOpacity,
            strokeStyle: e.strokeStyle,
            zIndex: e.zIndex
          }, null, 8, ["latLngList", "endArrow", "strokeWeight", "strokeColor", "strokeOpacity", "strokeStyle", "zIndex"])) : b("", !0)
        ]))), 128))
      ])) : b("", !0),
      e.markerList && e.showMarkerOrder ? (c(), h("div", V, [
        (c(!0), h(O, null, I(e.markerList, (l, o) => (c(), w(f(z), {
          key: o,
          lat: l.lat,
          lng: l.lng,
          "y-anchor": 0,
          content: r(l.order !== void 0 ? l.order : o, l.orderBottomMargin)
        }, null, 8, ["lat", "lng", "content"]))), 128))
      ])) : b("", !0),
      _(n.$slots, "default")
    ], 64));
  }
}), X = {
  install: (p) => {
    p.component("KakaoMap", T), p.component("KakaoMapMarker", B), p.component("KakaoMapCustomOverlay", z), p.component("KakaoMapInfoWindow", x), p.component("KakaoMapMarkerPolyline", q), p.component("KakaoMapPolyline", W);
  }
};
export {
  T as KakaoMap,
  z as KakaoMapCustomOverlay,
  x as KakaoMapInfoWindow,
  B as KakaoMapMarker,
  q as KakaoMapMarkerPolyline,
  W as KakaoMapPolyline,
  X as Vue3KakaoMaps,
  m as isKakaoMapApiLoaded,
  Q as useKakao
};
